import React, { useState } from 'react';
import { Grid, Container, IconButton } from "@mui/material"
import Icon from "../../utils/icon";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Carousel } from "../carousel/carousel"
import { ThumbnailCarousel } from "../thumbnailCarousel/thumbnailCarousel"


const PropertyGallery = ({ content, bgData }) => {

    const [[page, direction], setPage] = useState([0, 0]);

    const paginate = (newDirection) => {
        setPage([page + newDirection, newDirection]);
    };

    //lightbox
    const slides = content || []

    //if slider has a gallery
    function hasGallery() {

        var noImages = ""

        var imageUrls = slides.filter(
            edge => edge
        )

        if (imageUrls.length < 1 || imageUrls === undefined) {
            return noImages
        } else {
            return imageUrls.map(image => `${image.url}?width=1920&scale=both&quality=70`)

        }

    }

    const imageUrls = hasGallery()


    //lightbox state
    const [lightboxState, setLightboxState] = useState({
        photoIndex: 0,
        isOpen: false,
    })

    const { photoIndex, isOpen } = lightboxState



    return (

        <Container maxWidth="xl">
            <Grid container spacing={{ xs: 0, md: 3 }}>
                <Grid item xs={12} md={9} sx={{ overflow: 'hidden', maxWidth: '100%', position: 'relative' }}>
                    <Carousel autoPlay={false} images={content} bgData={bgData} page={page} direction={direction} paginate={paginate} imageSize="xl" />
                    <IconButton sx={{
                        display: 'flex',
                        alignItems: 'center',
                        border: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        padding: '1rem',
                        position: 'absolute',
                        zIndex: 99,
                        bottom: '1.5rem',
                        left: '50%',
                        transform: { xs: 'translateX(-50%)', md: 'translateX(50%)' },
                        borderRadius: '50%',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 1)'
                        }
                    }} type="button" onClick={() => setLightboxState(setIt => ({ ...setIt, isOpen: true }))}>
                        <Icon name="expand" height="1rem" />
                    </IconButton>
                </Grid>
                <Grid item xs={12} md={3} sx={{ display: { xs: 'none', md: 'block' } }}>
                    <ThumbnailCarousel images={content} paginate={paginate} currentIndex={page} imageSize="md" />
                </Grid>
            </Grid>







            {
                isOpen && (
                    <Lightbox
                        mainSrc={imageUrls[photoIndex]}
                        nextSrc={imageUrls[(photoIndex + 1) % imageUrls.length]}
                        prevSrc={imageUrls[(photoIndex + imageUrls.length - 1) % imageUrls.length]}
                        onCloseRequest={() => setLightboxState({ photoIndex: 0, isOpen: false })}
                        onMovePrevRequest={() =>
                            setLightboxState(setIt => ({
                                ...setIt,
                                photoIndex: (photoIndex + imageUrls.length - 1) % imageUrls.length,
                            }))
                        }
                        onMoveNextRequest={() =>
                            setLightboxState(setIt => ({
                                ...setIt,
                                photoIndex: (photoIndex + 1) % imageUrls.length,
                            }))
                        }
                    />
                )
            }

        </Container >

    )
}

export default PropertyGallery